import { Rows3 } from "lucide-react";
import { RiForward5Line } from "react-icons/ri";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "100%",

      rows: {
        row1: [
          {
            name: "exportNoteDate",
            label: "Date",
            component: "dateselector",
            width: "100%",
            required: true,
          },
        ],

        row2: [
          {
            name: "exportNotesPredefined",
            label: "Predefined Notes",
            component: "text-field",

          },
        ],

        row3: [
          {
            name: "exportNotes",
            actionText: "Notes",
            component: "textarea",
            height: "100px",
            sx: {
              borderRadius: "10px",
            },
            required: true,
          },
        ],
        row4: [
          {
            name: "exportNoteAttachment",
            label: "Attached",
            component: "fileselector",
            allowedFileTypes: "PDF, TXT, CSV, XLS, XLSX, DOC, DOCX, JPG, JPEG, PNG, TIFF, ZIP, RAR",
            width: "100%"
          },
        ],
      },
    },
  ],
};
